import React from 'react';
import SubfolderSlider from '../SubfolderSlider';
import { compose } from 'redux';
import withCurrentGallectionSubfolders from '../../_hocs/withCurrentGallectionSubfolders';
import withCurrentSubfolder from '../../_hocs/withCurrentSubfolder';
import FolderCard from '../../../FolderCard';
var enhance = compose(withCurrentGallectionSubfolders, withCurrentSubfolder);
export var SelectableSubfolderSlider = function (_a) {
    var subfolders = _a.subfolders, currentSubfolderId = _a.currentSubfolderId, setCurrentSubfolderId = _a.setCurrentSubfolderId;
    if (!subfolders.length) {
        return null;
    }
    return (React.createElement(SubfolderSlider, null, subfolders.map(function (subfolder, index) { return (React.createElement(FolderCard, { width: 128, isSelected: subfolder.folderId === currentSubfolderId, onClick: function () { return setCurrentSubfolderId(subfolder.folderId); }, withLink: false, key: subfolder.folderId, folder: subfolder, withCommentsCount: false })); })));
};
SelectableSubfolderSlider.displayName = 'SubfolderSliderSelector';
export default enhance(SelectableSubfolderSlider);
//# sourceMappingURL=SelectableSubfolderSlider.js.map